module.exports = __webpack_public_path__ + "img/footer-grexy-game-icon.2622aa8f.svg";